/**
 * Peek carousel: a row of cards that scrolls sideways with the next card cut at the edge.
 *
 * Build it in Elementor from the saved template "SSF Peek Carousel" (classes peek, peek-top,
 * peek-ctrl, peek-track, peek-card). This file adds the controls: previous and next buttons,
 * a "01 / 04" counter and a progress line, plus mouse drag and arrow keys. Touch uses native
 * swipe with scroll snap. It never moves on its own. If the page has no .peek-track, nothing runs.
 * The same file loops the text of any .marquee-track (see marquee() below).
 *
 * @package Sitamaa_Sahayata_Foundation
 */

( function () {
	'use strict';

	var ARROW = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';

	function pad( n ) {
		return ( n < 10 ? '0' : '' ) + n;
	}

	function button( label, cls ) {
		var b = document.createElement( 'button' );
		b.type = 'button';
		b.className = 'peek-btn ' + cls;
		b.setAttribute( 'aria-label', label );
		b.innerHTML = ARROW;
		return b;
	}

	function setup( track ) {
		var root = track.closest( '.peek' ) || track.parentNode;
		var cards = Array.prototype.slice.call( track.children );
		if ( cards.length < 2 ) {
			return;
		}

		var ctrl = root.querySelector( '.peek-ctrl' );
		if ( ! ctrl ) {
			ctrl = document.createElement( 'div' );
			ctrl.className = 'peek-ctrl';
			track.parentNode.insertBefore( ctrl, track );
		}

		var count = document.createElement( 'span' );
		count.className = 'peek-count';
		count.setAttribute( 'aria-live', 'polite' );
		var t = window.ssfText || {};
		var prev = button( t.prev || 'Previous', 'peek-prev' );
		var next = button( t.next || 'Next', 'peek-next' );
		ctrl.innerHTML = '';
		ctrl.appendChild( count );
		ctrl.appendChild( prev );
		ctrl.appendChild( next );

		var bar = document.createElement( 'div' );
		bar.className = 'peek-bar';
		bar.setAttribute( 'aria-hidden', 'true' );
		bar.innerHTML = '<i></i>';
		track.parentNode.insertBefore( bar, track.nextSibling );
		var fill = bar.firstChild;

		track.setAttribute( 'tabindex', '0' );
		track.setAttribute( 'role', 'region' );
		if ( ! track.hasAttribute( 'aria-label' ) ) {
			track.setAttribute( 'aria-label', 'Scroll sideways to see more' );
		}

		function step() {
			return cards[ 1 ].offsetLeft - cards[ 0 ].offsetLeft;
		}

		function update() {
			var max = track.scrollWidth - track.clientWidth;
			var i = Math.round( track.scrollLeft / step() );
			if ( track.scrollLeft >= max - 4 ) {
				i = cards.length - 1;
			}
			i = Math.max( 0, Math.min( cards.length - 1, i ) );
			count.textContent = pad( i + 1 ) + ' / ' + pad( cards.length );
			prev.disabled = track.scrollLeft < 4;
			next.disabled = track.scrollLeft >= max - 4;
			fill.style.width = ( 100 / cards.length ) + '%';
			fill.style.transform = 'translateX(' + ( i * 100 ) + '%)';
		}

		prev.addEventListener( 'click', function () {
			track.scrollBy( { left: -step() } );
		} );
		next.addEventListener( 'click', function () {
			track.scrollBy( { left: step() } );
		} );
		track.addEventListener( 'keydown', function ( e ) {
			if ( 'ArrowRight' === e.key || 'ArrowLeft' === e.key ) {
				e.preventDefault();
				track.scrollBy( { left: 'ArrowRight' === e.key ? step() : -step() } );
			}
		} );
		track.addEventListener( 'scroll', function () {
			window.requestAnimationFrame( update );
		}, { passive: true } );

		// Mouse drag; a drag does not count as a click on a card link.
		var down = false;
		var moved = false;
		var startX = 0;
		var startLeft = 0;
		track.addEventListener( 'pointerdown', function ( e ) {
			if ( 'mouse' !== e.pointerType ) {
				return;
			}
			down = true;
			moved = false;
			startX = e.clientX;
			startLeft = track.scrollLeft;
		} );
		window.addEventListener( 'pointermove', function ( e ) {
			if ( ! down ) {
				return;
			}
			var dx = e.clientX - startX;
			if ( Math.abs( dx ) > 4 ) {
				moved = true;
				track.classList.add( 'is-drag' );
			}
			track.scrollLeft = startLeft - dx;
		} );
		window.addEventListener( 'pointerup', function () {
			if ( ! down ) {
				return;
			}
			down = false;
			track.classList.remove( 'is-drag' );
			track.scrollTo( { left: Math.round( track.scrollLeft / step() ) * step() } );
		} );
		track.addEventListener( 'click', function ( e ) {
			if ( moved ) {
				e.preventDefault();
				moved = false;
			}
		}, true );

		window.addEventListener( 'resize', update );
		update();
	}

	/*
	 * Marquee (classes marquee > marquee-track > marquee-item): the words are written once in
	 * Elementor; here a copy is appended, hidden from screen readers, so the CSS animation can
	 * loop without a gap. Under reduced motion style.css stops it and lets the words wrap.
	 */
	function marquee( track ) {
		if ( track.dataset.looped ) {
			return;
		}
		Array.prototype.slice.call( track.children ).forEach( function ( item ) {
			var copy = item.cloneNode( true );
			copy.setAttribute( 'aria-hidden', 'true' );
			copy.classList.add( 'is-copy' );
			track.appendChild( copy );
		} );
		track.dataset.looped = '1';
	}

	function init() {
		if ( document.body.classList.contains( 'elementor-editor-active' ) ) {
			return;
		}
		Array.prototype.forEach.call( document.querySelectorAll( '.peek-track' ), setup );
		Array.prototype.forEach.call( document.querySelectorAll( '.marquee-track' ), marquee );
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
}() );
